//静默登录辅助工具
import HttpService from '../../api/service/HttpServices'
import store from '../../store/'
import Vue from 'vue'
import { ACCESS_TOKEN, USER_INFO_KEY } from '@/store/mutation-types'

export default class SilentLoginHelper {
  //to.query.token
  static silentLogin(next, redirectSuccess, redirectError, token) {
    store.dispatch('clearLocalData')//清除原来的登录状态
      .then(() => {
        return HttpService.getUserService().post('merchant/v2/getUserByToken', {}, { token: token })//获取新的登录信息
      })
      .then(userInfo => {
        if (userInfo.account >= 3) {
          Vue.ls.set(ACCESS_TOKEN, userInfo.token, 7 * 24 * 60 * 60 * 1000)
          Vue.ls.set(USER_INFO_KEY, userInfo, 7 * 24 * 60 * 60 * 1000)
          store.commit('SET_TOKEN', userInfo.token)
          next({ path: redirectSuccess, replace: true })
          console.log('========userInfo==静默登录成功======', userInfo)
        } else {
          next({ path: redirectError, replace: true })
        }
      }).catch(reason => {
      console.log('========静默登录失败========', reason)
      next({ path: redirectError, replace: true })
    })
  }

  static silentLoginCode(next, redirectSuccess, redirectError, code) {
    store.dispatch('clearLocalData')//清除原来的登录状态
      .then(() => {
        return HttpService.getUserService().post('merchant/v2/ict/defaultMerchantInfoLogin', { code: code }, {})//获取新的登录信息
      })
      .then(userInfo => {
        if (userInfo.account >= 3) {
          Vue.ls.set(ACCESS_TOKEN, userInfo.token, 7 * 24 * 60 * 60 * 1000)
          Vue.ls.set(USER_INFO_KEY, userInfo, 7 * 24 * 60 * 60 * 1000)
          store.commit('SET_TOKEN', userInfo.token)
          next({ path: redirectSuccess, replace: true })
          console.log('========userInfo==静默登录成功======', userInfo)
        } else {
          next({ path: redirectError, replace: true })
        }
      }).catch(reason => {
      console.log('========静默登录失败========', reason)
      next({ path: redirectError, replace: true })
    })
  }
}
